<template>
    <div style="width: 100%">
        <div class="comment-item" v-for="item in tableData" :key="item.uuid">
            <div style="display: flex">
                <img v-if="item.user && item.user.avatar" class="avatar" :src="ossUrl + item.user.avatar" alt="" />
                <div v-else class="avatar-none"></div>
                <div class="info">
                    <div class="top">
                        <div class="name">{{ item.user_nick_name }}</div>
                        <div>
                            <div class="product">商品：{{ item.goods_name }}</div>
                            <div class="comment">{{ item.content }}</div>
                        </div>
                    </div>
                    <div class="pics">
                        <div v-for="pic in item.images" :key="pic.id">
                            <video controls v-if="isVideo(pic.url)" :src="formatter(pic.url)"></video>
                            <img v-else @click="handlePreview(pic.url)" :src="formatter(pic.url)" alt="" />
                        </div>
                    </div>
                    <div class="time">{{ item.create_time }}</div>
                </div>
            </div>
            <div v-if="item.status == 3">已拒绝</div>
            <div v-else class="btns" style="min-width: max-content">
                <el-link type="primary" v-if="permission('cpgl_plsh_tg')" :underline="false" @click="handleStatus(item.uuid, 1)">通过</el-link>
                <el-link type="danger" v-if="permission('cpgl_plsh_jj')" :underline="false" @click="handleStatus(item.uuid, 3)">拒绝</el-link>
            </div>
        </div>
        <PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import { list, status } from "@/api/product/comment";
import listMixin from "@/mixins/list";
import { ossUrl } from "@/configs/oss";
import PicPreviewer from "@/components/PicPreviewer";
export default {
    components: { PicPreviewer },
    data() {
        return {
            list,
            status,
            ossUrl,
            // 查询参数
            query: {
                search_keyword: "",
                search_status: "2",
                page_size: 999999,
            },
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleStatus(uuid, status) {
            this.status({ uuid, status }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(status == 1 ? "已通过" : "已拒绝");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        formatter(url) {
            if (url.indexOf("http") > -1) {
                return url;
            }
            return this.ossUrl + url;
        },
        handlePreview(url) {
            this.$refs.preview.open(url);
        },
        isVideo(url) {
            let res = false;
            [
                ".mp4",
                ".MP4",
                ".avi",
                ".AVI",
                ".mov",
                ".MOV",
                ".wmv",
                ".WMV",
                ".mpg",
                ".MPG",
                ".rm",
                ".RM",
                ".rmvb",
                ".RMVB",
                ".flv",
                ".FLV",
                ".mkv",
                ".MKV",
                ".f4v",
                ".F4V",
                ".mpeg",
                ".MPEG",
            ].forEach((x) => {
                if (url.indexOf(x) > -1) {
                    res = true;
                }
            });
            return res;
        },
    },
};
</script>

<style lang="less" scoped>
.comment-item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 20px;
        margin-top: 20px;
    }
    .avatar-none {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        background: #eee;
        margin-right: 20px;
        margin-top: 20px;
    }
    .btns {
        display: flex;
        column-gap: 10px;
        align-self: flex-start;
    }
    .top {
        display: flex;
        .name {
            min-width: 100px;
            margin-right: 10px;
        }
        .product {
            color: #999;
            margin-bottom: 20px;
        }
    }
    .time {
        color: #999;
        margin-top: 20px;
    }
    .pics {
        display: flex;
        gap: 10px;
        margin-top: 20px;
        flex-wrap: wrap;
        img {
            height: 90px;
            max-width: 100%;
        }
        video {
            height: 300px;
            max-width: 100%;
        }
    }
}
</style>
